(function () {
  // Add-on script: injects bundle child products into the existing AJAX cart
  // drawer without touching the theme's existing render logic.

  function fetchBundleData() {
    return fetch('/?section_id=cart-bundle-data&t=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var script = doc.getElementById('CartBundleData');
        if (!script) return {};
        try {
          return JSON.parse(script.textContent);
        } catch (e) {
          console.error('cart-bundle-inject: failed to parse bundle data', e);
          return {};
        }
      });
  }

  // Builds the collapsible toggle
  function buildBundleWidget(components) {
    var wrapper = document.createElement('div');
    wrapper.className = 'mpb_fbt_cart-bundle';

    var itemsHtml = components.map(function (component) {
      var variantHtml = (component.variant_title && component.variant_title !== 'Default Title')
        ? ' - ' + component.variant_title
        : '';
      var imgHtml = component.image
        ? '<img src="' + component.image + '" alt="' + component.title.replace(/"/g, '&quot;') + '" width="30" height="30" loading="lazy" class="mpb_fbt_cart-bundle__img">'
        : '';
      return (
        '<li class="mpb_fbt_cart-bundle__item">' +
          imgHtml +
          '<span class="mpb_fbt_cart-bundle__title">' + component.quantity + ' x ' + component.title + variantHtml + '</span>' +
        '</li>'
      );
    }).join('');

    wrapper.innerHTML =
      '<button type="button" class="mpb_fbt_cart-bundle__toggle" aria-expanded="true" data-count="' + components.length + '">' +
        '<span class="mpb_fbt_cart-bundle__toggle-icon">' +
          '<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</span>' +
        '<span class="mpb_fbt_cart-bundle__toggle-text">Hide ' + components.length + ' items</span>' +
      '</button>' +
      '<div class="mpb_fbt_cart-bundle__list-wrapper">' +
        '<ul class="mpb_fbt_cart-bundle__list">' + itemsHtml + '</ul>' +
      '</div>';

    return wrapper;
  }

  var bundleRequestId = 0;

    function injectBundleChildren() {
    var requestId = ++bundleRequestId;

    fetchBundleData().then(function (data) {
        if (requestId !== bundleRequestId) return; // có lần add mới hơn xảy ra trong lúc chờ -> bỏ kết quả cũ này
        if (!data) data = {};

        document.querySelectorAll('.ajaxcart__product[data-key]').forEach(function (row) {
        var key = row.getAttribute('data-key');

        // luôn xoá widget cũ trước, để không bao giờ giữ data sai từ lần add trước
        var oldWidget = row.querySelector('.mpb_fbt_cart-bundle');
        if (oldWidget) oldWidget.remove();

        var components = data[key];
        if (!components || !components.length) return;

        var twoThirds = row.querySelector('.grid__item.two-thirds');
        if (!twoThirds) return;

        var widget = buildBundleWidget(components);
        var infoGrids = twoThirds.querySelectorAll(':scope > .grid.grid--full.display-table');
        if (infoGrids.length > 0) {
            infoGrids[0].insertAdjacentElement('afterend', widget);
        } else {
            twoThirds.appendChild(widget);
        }
        });
    });
    }

  // theme.CartDrawer's buildCart() already triggers `updateCart.ajaxcart` on
  // <body> every time the drawer re-renders (add/update/remove/page load)
  if (window.jQuery) {
    jQuery('body').on('updateCart.ajaxcart', function () {
      // small delay so this runs after the template HTML is appended to #CartContainer
      setTimeout(injectBundleChildren, 30);
    });
  } else {
    // fallback in case jQuery isn't available in this scope
    document.body.addEventListener('updateCart.ajaxcart', function () {
      setTimeout(injectBundleChildren, 30);
    });
  }

  // Toggle expand/collapse
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mpb_fbt_cart-bundle__toggle');
    if (!btn) return;

    var wrapper = btn.nextElementSibling;
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    var count = btn.getAttribute('data-count');
    var textEl = btn.querySelector('.mpb_fbt_cart-bundle__toggle-text');

    btn.setAttribute('aria-expanded', String(!expanded));

    if (expanded) {
      wrapper.classList.add('is-collapsed');
      textEl.textContent = 'Show ' + count + ' items';
    } else {
      wrapper.classList.remove('is-collapsed');
      textEl.textContent = 'Hide ' + count + ' items';
    }
  });
})();